import { render, staticRenderFns } from "./ConfigureSlots.vue?vue&type=template&id=146e3a58&"
import script from "./ConfigureSlots.vue?vue&type=script&lang=js&"
export * from "./ConfigureSlots.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureSlots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports